import React from "react";
import ProductGroupList from "./ProductGroupList";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";

interface Props {
  selectedProductGroups: server.dto.ProductGroup[]
  onChange: (newProductGroups: server.dto.ProductGroup[]) => void
}

const ProductGroupMultiPicker = (props: Props) => {

  return <MultiPickerSelectedItems
    selectedItems={props.selectedProductGroups}
    onRemove={props.onChange}
    getId={productGroup => productGroup.productGroupId}
    getLabel={productGroup => <div>
      {productGroup.title}
    </div>}
  >
    <ProductGroupList
      onItemSelected={(item) => props.onChange([...props.selectedProductGroups, item])}
      excludeKeys={props.selectedProductGroups.map(cc => cc.productGroupId)}
    />
  </MultiPickerSelectedItems>;
};

export default ProductGroupMultiPicker;